import React from 'react';
import { Icon } from 'semantic-ui-react';

const CanvasPreview = (props) => {
  const { canvasObj } = props;
  const showCanvas = (canvasId) => {
    try {
      window.FB.ui(
        {
          display: 'popup',
          method: 'instant_experiences_preview',
          canvas_id: canvasId
        },
        (res) => {
          return res;
        }
      );
    } catch (error) {
      console.log('Error with canvas preview dialog:', error);
    }
  };

  if (!canvasObj.name) {
    return null;
  }

  return (
    <div>
      Canvas Name: <b>{canvasObj.name}</b>
      <Icon
        size="large"
        className="canvas-link"
        onClick={() => showCanvas(canvasObj.id)}
        name="eye"
      />
      {props.destinationUrl ? (
        <div className="canvas-container-destinationUrl">
          Destination Url: <b>{props.destinationUrl}</b>
        </div>
      ) : null}
      <a
        href={`${props.destinationUrl}`}
        // eslint-disable-next-line react/jsx-no-target-blank
        target="_blank"
        style={{ color: 'black' }}
      >
        <Icon size="large" className="canvas-link" name="eye" />
      </a>
      {props.productSetName ? (
        <div className="canvas-container-productSet">
          Product Set: <b>{props.productSetName}</b>
        </div>
      ) : null}
    </div>
  );
};

export default CanvasPreview;



// WEBPACK FOOTER //
// ./src/components/common/CanvasPreview.js